/* eslint key-spacing: 'off', comma-spacing: 'off' */
//import CtColumn from '@/bo/CtColumn';
import * as XLSX from "xlsx";

export default function XlsxSheetBuilder () {
    this.rows = [];
    this.cellMerges = [];
    this.columnWidths = [];
  }

XlsxSheetBuilder.prototype.addBlankLine = function() {
  this.rows.push([]);
}
XlsxSheetBuilder.prototype.addRow = function(row) {
  this.rows.push(row);
}
XlsxSheetBuilder.prototype.mergeCellAcrossRows = function (column, numberOfRows) {
    var thisRow = this.rows.length;
    this.cellMerges.push({ s: { c: column, r: thisRow }, e: { c: column, r: thisRow + numberOfRows - 1 } });
}

XlsxSheetBuilder.prototype.mergeCellAcrossColumns = function (firstColumn, lastColumn) {
    var thisRow = this.rows.length - 1;
    this.cellMerges.push({ s: { c: firstColumn, r: thisRow }, e: { c: lastColumn, r: thisRow } });
}

XlsxSheetBuilder.prototype.toSheet = function() {
  /* convert an array of arrays in JS to a CSF spreadsheet */
  var ws = XLSX.utils.aoa_to_sheet(this.rows, { cellDates: true });

  /* TEST: column props */
  ws['!cols'] = this.columnWidths;

  ////Only v and t are set.  t = "s", v is the value of the cell
  //ws['A6'].s = {
  //  wrapText: true,
  //  alignment: { wrapText: true }
  //};

  ws['!merges'] = this.cellMerges;
  return ws;
}

